import { FC, useState } from 'react';

import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Menu } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

import styles from './Header.module.scss';
import { routeNames } from '../../constants/routes';
import PermissionWrapper from '../../hoc/PermissionWrapper';
import { useActions } from '../../hooks/useActions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import SchoolModal from '../nav/components/Modal';
export const endImpersonation = () => {
  localStorage.setItem('access', localStorage.getItem('access_admin')!);
  localStorage.removeItem('access_admin');
  window.location.href = '/crm/users';
};
const Header: FC = () => {
  const navigate = useNavigate();

  const { authLogout, setActiveMainTab } = useActions();
  const { name, role } = useTypedSelector((state) => state.currentUser);
  const { userAccess, selectedSchool, schoolList } = useTypedSelector(
    (state) => state.currentSchool
  );
  const { currentSchoolChange, fetchUserAndSchoolInfo } = useActions();

  const [ isModalVisible, setIsModalVisible ] = useState(false);

  const userMenuItems = [
    {
      key: '1',
      label: <Link to={routeNames.profile}>Профиль</Link>,
    },
    {
      key: '2',
      label: <span>Выход</span>,
      onClick: () =>
        authLogout(() => {
          navigate(routeNames.login);
        }),
    },
    localStorage.getItem('access_admin')
      ? {
          key: '3',
          label: <span>Выйти из пользователя</span>,
          onClick: () => endImpersonation(),
        }
      : null,
  ];

  const crmMenuItems = [
    {
      key: '1',
      label: <Link to={routeNames.crmSchool}>Школы</Link>,
    },
    {
      key: '2',
      label: <Link to={routeNames.crmUsers}>Пользователи</Link>,
    },
    {
      key: '3',
      label: <Link to={routeNames.crmOrders}>Заказы</Link>,
    },
    {
      key: '4',
      label: <Link to={routeNames.crmPayments}>Платежи</Link>,
    },
    {
      key: '5',
      label: <Link to={routeNames.crmTariffs}>Тарифы</Link>,
    },
    {
      key: '6',
      label: <Link to={routeNames.crmActivity}>Активность</Link>,
    },
    {
      key: '7',
      label: <Link to={routeNames.crmDetails}>Детализация</Link>,
    },
    {
      key: '8',
      label: <Link to={routeNames.crmPartner}>Партнёрская программа</Link>,
    },
    {
      key: '9',
      label: <Link to={routeNames.crmRequests}>Запросы</Link>,
    },
  ];

  const changeSchool = (id: string) => {
    currentSchoolChange(id, () => {
      fetchUserAndSchoolInfo(navigate);
      window.location.reload();
    });
  };

  const handleSchoolClick = () => {
    setIsModalVisible(true); // Открываем модальное окно при клике на школу
  };

  return (
      <Layout.Header className={styles.headerContainer}>
        <div>
          <Link
            to="/"
            className={styles.logoWrapper}
            onClick={() => setActiveMainTab('overview')}
          >
            <img style={{ width: '165px' }} alt="SCAN" src="/400.png" />
          </Link>
          <div className={styles.schoolSelectorWrapper}>
            <Menu
              className={styles.schoolName}
              style={{
                borderRadius: '30px',
                textAlign: 'center',
                background: 'none',
              }}
              mode="inline"
              selectable={false}
            >
              <Menu.Item
                onClick={(e) => {
                  handleSchoolClick();
                  e.domEvent.currentTarget.blur();
                }}
                style={{
                  cursor: 'pointer',
                  fontSize: '16px',
                  paddingLeft: '17px',
                }}
              >
                {selectedSchool?.name || 'Выберите школу'}
                <DownOutlined style={{ fontSize: 14, marginLeft: 12 }} />
              </Menu.Item>
            </Menu>
          </div>
          {/* <SchoolDropdowns/> */}
        </div>

        <div>
          <div
            style={{
              marginRight: 25,
            }}
            className={styles.headerBill}
          >
          {role === 'superadmin' && <Dropdown
            menu={{ items: crmMenuItems }}
            placement="bottom"
            trigger={[ 'click' ]}
          >
            <Button
                  type="primary"
                  style={{
                    padding: '2px 10px',
                    backgroundColor: 'white',
                    color: 'black',
                    borderColor: 'black',
                    borderRadius: '5px',
                    marginRight: '10px'
                  }}
                >
                  CRM
                </Button>
          </Dropdown>}
            <Button
              type="primary"
              style={{
                padding: '2px 10px',
                marginRight: 12,
                borderRadius: '5px',
              }}
            >
              <a href="https://t.me/analytics_scan" target="_blank">
                Написать в поддержку
              </a>
            </Button>
            {selectedSchool && (
              <PermissionWrapper
                allowedRoles={[ 'admin', 'user:settings' ]}
                redirectToErrPage={false}
                returnedElement={<div />}
              >
                <Button
                  type="primary"
                  style={{
                    padding: '2px 10px',
                    backgroundColor: 'white',
                    color: 'black',
                    borderColor: 'black',
                    borderRadius: '5px',
                  }}
                >
                  <Link to={routeNames.bill}>Биллинг</Link>
                </Button>
              </PermissionWrapper>
            )}
          </div>

          {selectedSchool && (
            <PermissionWrapper
              allowedRoles={[ 'admin', 'user:settings' ]}
              redirectToErrPage={false}
              returnedElement={<div />}
            >
              <Link className={styles.licenceInfo} to={routeNames.bill}>
                <p>Доступ до {userAccess?.date || '-'}</p>
                <p>Осталось {userAccess?.days || '0'} дней</p>
              </Link>
            </PermissionWrapper>
          )}

          <Dropdown
            menu={{ items: userMenuItems }}
            placement="bottom"
            trigger={[ 'click' ]}
          >
            <div className={styles.userInfo}>
              <Avatar size="default" icon={<UserOutlined />} />
              <span>{name || 'Пользователь'}</span>
            </div>
          </Dropdown>
        </div>
        <SchoolModal
          visible={isModalVisible}
          onClose={() => {
            setIsModalVisible(false);
          }}
          schoolList={schoolList || {}}
          selectedSchool={selectedSchool}
          changeSchool={changeSchool}
        />
      </Layout.Header>
  );
};

export default Header;
